import readXlsxFile from 'read-excel-file'
import {validatenull} from '@/util/validate'
import {Message} from 'element-ui'

//导入文件
export function exportFileCommon(file = '', isDelFirst = true, dataLength = 0) {
	if (!file || dataLength <= 0) {
		return Promise.reject(new Error('导入数据为空'))
	}
	return new Promise((resolve, reject) => {
		readXlsxFile(file.raw)
			.then((response) => {
				if (response.length === 1) {
					reject(new Error('导入数据为空'))
				}
				//是否删除第一行
				if (isDelFirst) {
					response.splice(0, 1)
				}
				//暂存数据
				let resList = []
				response.forEach((itemData) => {
					//去除空格！
					let tempResult = true
					for (let i = 0; i < dataLength; i++) {
						let tempItem = `${itemData[i]}` || ''
						if (!validatenull(tempItem)) {
							itemData[i] = tempItem.replace(/\s+/g, '')
						}
						if (validatenull(itemData[i])) {
							tempResult = false
						}
					}
					if (tempResult) {
						resList.push(itemData)
					}
				})
				if (resList.length === 0) {
					reject(new Error('导入数据为空'))
				}
				resolve(resList)
			})
			.catch((error) => {
				reject(error)
			})
	})
}

export function dataURLtoBlob(dataUrl) {
	let arr = dataUrl.split(','),
		mime = arr[0].match(/:(.*?);/)[1],
		bstr = atob(arr[1]),
		n = bstr.length,
		u8arr = new Uint8Array(n)
	while (n--) {
		u8arr[n] = bstr.charCodeAt(n)
	}
	return new Blob([u8arr], {type: mime})
}

export function downloadExportFile(blob, fileName, fileType) {
	const downloadElement = document.createElement('a')
	let href = blob
	if (typeof blob === 'string') {
		downloadElement.target = '_blank'
	} else {
		href = window.URL.createObjectURL(blob) // 创建下载的链接
	}
	downloadElement.href = href
	downloadElement.download = fileName + '.' + fileType // 下载后文件名
	document.body.appendChild(downloadElement)
	downloadElement.click() // 触发点击下载
	document.body.removeChild(downloadElement) // 下载完成移除元素
	if (typeof blob !== 'string') {
		window.URL.revokeObjectURL(href) // 释放掉blob对象
	}
}
